import axios from "axios";
import fetchToken from "./fetchToken";
import paramsSerializer from "./paramsSerializer";

const preventPagination = request => {
  if (request.params && request.params.pagination !== undefined) {
    throw new Error('"pagination" parameter is now forbidden.');
  }

  return request;
};

let authorizationProvider = fetchToken;

export const setAuthorizationProvider = provider => {
  authorizationProvider = provider;
};

const addAuthorizationHeader = request => {
  return authorizationProvider
    ? authorizationProvider().then(requestToken => ({
        ...request,
        headers: {
          ...request.headers,
          Authorization: "Bearer " + requestToken
        }
      }))
    : request;
};

let client;

function createHttpClient() {
  if (!client) {
    // create axios client with custom params serializer
    client = axios.create({
      baseURL: process.env.REACT_APP_SHADOW_API_BASE_URL,
      paramsSerializer
    });

    // create interceptors
    client.interceptors.request.use(preventPagination);
    client.interceptors.request.use(addAuthorizationHeader);
  }

  return client;
}

export default createHttpClient;



// WEBPACK FOOTER //
// ./src/shadow-client/axios/createClient.js